<template>
  <div>
    <div class='conter'>
      <img
        style="width:100%;"
        src="../../assets/imgs/publicCredit/creditService.png"
      >
      <img
        style="width:100%;"
        src="../../assets/imgs/publicCredit/publicCredit.png"
        alt=""
      >
      <div class='search'>
        <img src="../../assets/imgs/publicCredit/search.png">
        <el-input
          style="height: 100px; font-size:24px"
          v-model="input"
          placeholder="请输入企业代码或企业名称"
        ></el-input>
        <!-- <el-button
          class='button'
          @click="compList()"
        >查询</el-button> -->
        <el-button
          class='button'
          @click="cli_details(input)"
        >查询</el-button>
      </div>
      <div class="searBox">
        <!-- <div class='title mySize'>搜索结果</div> -->
        <!-- <div class='details'>
          <div
            class='list'
            @click="cli_details(item.companyId)"
            v-for="(item,index) in listTitle"
            :key="index"
          >
            <div class='listTitle'>
              <div class='listTitleText'>{{item.d2CorpName}}</div>
              <div class='status'>{{item.d2EntStatus}}</div>
            </div>
            <div class='listBtn'>统一社会信用代码: {{item.corpKey}}</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { compList, compDetail } from '@/api/publicCredit'
export default {
  data () {
    return {
      input: '',
      listTitle: []
    }
  },
  methods: {
    cli_details (id) {
      this.$router.push({
        path: '/xyd/creditDetails',
        query: {
          keyword: id
        }
      })
    },
    // compList () {
    //   let param = {
    //     corpKey: this.input
    //   }
    //   const res = compList(this.sendParam(param));
    //   Promise.resolve(res).then(value => {  //处理返回的Promise
    //     let key = this.RsaDecrypt(value.data.encrypted)
    //     let result = JSON.parse(this.AesDecrypt(value.data.requestData, key))
    //     if (result.code == 200) {
    //       this.listTitle = result.data
    //     } else {
    //       this.$message.error(result.msg);
    //     }
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
.conter {
  width: 100%;
  height: 100%;
  background-color: #f5f6fa;
  .search {
    width: 1000px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -50px auto 0 auto;
    box-shadow: 0px 0px 14px 0px rgba(26, 40, 79, 0.08);
    border-radius: 0px;
    background-color: #fff;
    z-index: 999;
    position: relative;
    box-sizing: border-box !important;
    img {
      position: absolute;
      z-index: 999;
      top: auto;
      left: 20px;
    }
    /deep/.el-input__inner {
      border: none;
      width: 100%;
      height: 100%;
      padding-left: 55px;
    }
    .button {
      width: 198px;
      height: 106px;
      background: linear-gradient(189deg, #51c1fa, #5295fd);
      border-radius: 0px;
      font-size: 28px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #fdfdfd;
      line-height: 81px;
    }
  }
  .searBox {
    margin: 52px 304px;
    padding-top: 27px;
    padding-bottom: 10px;
    min-height: 80px;
    .details {
      margin-top: 15px;
      min-height: 624px;
      box-sizing: border-box;
      // background-color: #fff;
    }
    .list {
      padding: 33px 42px;
      border-bottom: 2px solid #f3f4f9;
      // background-color: #fff;
      .listTitle {
        display: flex;
        align-items: center;
        .listTitleText {
          font-size: 22px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          line-height: 17px;
          margin-right: 17px;
        }
        .status {
          width: 44px;
          height: 24px;
          background: #ffffff;
          border: 1px solid rgba(69, 192, 110, 0.7);
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #4fb270;
          line-height: 17px;
          text-align: center;
          line-height: 24px;
        }
      }
      .listBtn {
        margin-top: 15px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
        line-height: 17px;
      }
    }
  }
}
</style>
